import { Link, NavLink, useHistory } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import { IoLogOutOutline } from "react-icons/io5";

import WithAuthentication from "Authentication/AuthenticationContext";
import { URL_ID } from "constants/constants.js";
import {
  FaCampground,
  FaChartBar,
  FaMoneyBillWaveAlt,
  FaUsersCog,
  FaUserTie,
  FaTicketAlt,
  FaList,
  FaUserAlt,
  FaShoppingBasket,
} from "react-icons/fa";
import { AiFillSetting, AiOutlineTransaction } from "react-icons/ai";

export default function CustomerSidebar({ classProp }) {
  const history = useHistory();

  const auth = useContext(WithAuthentication);
  function getButtonIcon(id: number): JSX.Element | undefined {
    switch (id) {
      case URL_ID.adminTourList.id:
        return <FaList className="fs-5"></FaList>;
      case URL_ID.adminCreateTour.id:
        return <FaCampground className="fs-18" />;
      case URL_ID.adminUserManagement.id:
        return <FaUsersCog className="fs-5" />;
      case URL_ID.adminUserReport.id:
        return <FaUserTie className="fs-5" />;
      case URL_ID.adminManagement.id:
        return <FaChartBar className="fs-18 " />;
      case URL_ID.adminFinancial.id:
        return <FaMoneyBillWaveAlt className="fs-5" />;
      case URL_ID.adminReservation.id:
        return <FaTicketAlt className="fs-5" />;
      case URL_ID.customerProfile.id:
        return <FaUserAlt className="fs-5" />;
      case URL_ID.customerDashboard.id:
        return <AiFillSetting className="fs-5" />;
      case URL_ID.customerTransactions.id:
        return <AiOutlineTransaction className="fs-5" />;
      case URL_ID.customerOrders.id:
        return <FaShoppingBasket className="fs-5" />;
    }
  }
  function addExtraButtons(): JSX.Element[] {
    let buttonsJSX: JSX.Element[] = [];
    let myAccessLevel = auth.userInfo.accessLevel;

    let data: any[];
    {
      let priority = [10, 5, 8, 9, 11, 12, 14, 13, 15, 16];

      data = Object.values(URL_ID).filter((value) =>
        priority.includes(value.id)
      );
      data.sort((a, b) => {
        let aIndex = priority.findIndex((value) => value == a.id),
          bIndex = priority.findIndex((value) => value == b.id);
        return aIndex - bIndex;
      });
    }
    data.forEach((val) => {
      if (myAccessLevel.find((value) => val.id == value)) {
        buttonsJSX.push(
          <li className={`nav-item d-block ${classProp}`}>
            <NavLink
              to={
                val.id == 9
                  ? `/admin-panel/user-report/${auth.userInfo.id}`
                  : val.route
              }
              exact
              className=" nav-link align-middle px-0 d-flex  header-item"
            >
              {getButtonIcon(val.id)}
              <div className="w-100 ms-2 ">{val.name}</div>
            </NavLink>
          </li>
        );
      }
    });

    return buttonsJSX;
  }

  return (
    <>
      <>
        <div className={`menu1 d-block  flex-nowrap d-block border `}>
          <div
            className={` d-flex flex-column flex-nowrap`}
            id="navbarTogglerDemo01"
            style={{ fontSize: "14px" }}
          >
            <div className=" nav nav-pills flex-column col-12 ">
              {/* <li className={`nav-item d-block menu-item`}>
                <NavLink
                  to={URL_ID.customerDashboard.route}
                  exact
                  className=" nav-link align-middle px-0 d-flex header-item"
                >
                  {getButtonIcon(URL_ID.customerDashboard.id)}
                  <div className="w-100 ms-2 ">
                    {URL_ID.customerDashboard.name}
                  </div>
                </NavLink>
              </li> */}
              {addExtraButtons()}
              {auth.isLogged && (
                <li
                  className={`nav-item d-block menu-item`}
                  style={{ fontSize: "14px" }}
                >
                  <div
                    className="nav-link align-middle px-0 py-0 my-1  header-item"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      auth.logout();
                      history.push("/");
                    }}
                  >
                    <span className="ms-1  d-sm-inline">
                      <IoLogOutOutline className="me-2"></IoLogOutOutline>
                      خروج
                    </span>
                  </div>
                </li>
              )}
            </div>
          </div>
        </div>
      </>
    </>
  );
}
